// src/utils/fetchPermissions.ts
import { ScanCommand } from "@aws-sdk/client-dynamodb";
import { COGNITO_USER_ID } from "@constants/cognitoAttributes";
import { fetchUserAttributes } from 'aws-amplify/auth';
import { dbClient } from "./awsClients";


const getRolesForUser = async (userId: string) => {
  const params = {
    TableName: 'role_user',
    FilterExpression: '#user_id = :user_id',
    ExpressionAttributeNames: {
      "#user_id": "user_id"
    },
    ExpressionAttributeValues: {
      ':user_id': { S: userId },
    }
  };
  
  const data = await dbClient.send(new ScanCommand(params));
  return data && data.Items ? data.Items[0].role_id?.S : '';
};

const getAllPermissions = async () => {
  const params = {
    TableName: 'permissions',
  };
  
  const data = await dbClient.send(new ScanCommand(params));

  if (!data.Items) {
    return [];
  }

  return data.Items ? data.Items : '';
};

const getPermissionsForRoles = async (roleId: string) => {

  const params = {
    TableName: 'permission_role',
    FilterExpression: '#role_id = :role_id',
    ExpressionAttributeNames: {
      "#role_id": "role_id"
    },
    ExpressionAttributeValues: {
      ':role_id': { S: roleId },
    }
  };
  
  const data = await dbClient.send(new ScanCommand(params));
  const permissionIds = data && data.Items ? data.Items.map(item => item.permission_id?.S) : '';

  if (permissionIds.length === 0) {
    return [];
  }

  const allPermissions = await getAllPermissions();
  if (!allPermissions) {
    return [];
  }
  // const allPermissionIds = allPermissions ? allPermissions.map(item => item.uuid?.S) : '';
  const filteredPermissions = allPermissions.filter(permission =>
    permission?.uuid?.S && permissionIds.includes(permission.uuid.S)
  );

  const permissionNames = filteredPermissions ? filteredPermissions.map(item => item.permission_name?.S) : '';
  return permissionNames;
};

export const fetchUserPermissions = async () => {
  const user = await fetchUserAttributes();
  
  if (!user || typeof user !== 'object') {
    throw new Error('User attributes are not available.');
  }
  
  const userId = user[COGNITO_USER_ID] ?? '';

  const roleId = await getRolesForUser(userId);
  const permissions = roleId ? await getPermissionsForRoles(roleId) : '';

  return permissions;
};
